import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../i18n/locales/en';
import ko from '../i18n/locales/ko';
import id from '../i18n/locales/id';
import { getBrowserLanguage } from '../utils/languageUtils';

const resources = {
  en: { translation: en },
  ko: { translation: ko },
  id: { translation: id }
};

// 저장된 언어가 있으면 사용, 없으면 브라우저 언어 설정 기반으로 설정
const savedLanguage = localStorage.getItem('language');
const initialLanguage = savedLanguage || getBrowserLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;